'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createClassListFilterFn = exports.extractInlineStyleText = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.parseInlineStyles = parseInlineStyles;
exports.filterInlineStyles = filterInlineStyles;
exports.stringifyInlineStyles = stringifyInlineStyles;

var _picoDom = require('@raywhite/pico-dom');

/**
 * This module deals with the parsing of inline styles so that
 * we're able to preserve some of the styling in markup content
 * generated by the WP. All of these functions assume that the
 * styles are not malformed... if we needed something more robust
 * we'd probably want to use a proper css parser like postCSS.
 *
 * SEE: `https://github.com/raywhite/office-sites/issues/1001`
 *
 * TODO: Since these functions would potentially run on a lot
 * of nodes, it might not be a terrible idea to use loops
 * instead of array methods... you know - for perf.
 */

/**
 * Takes the contents of a inline `style` attribute
 * and returns an object containing normalised key:value
 * pairs of css properties.
 *
 * @param {String}
 * @returns {Object}
 */
function parseInlineStyles() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  /**
   * Turns out to be relatively simple (assuming that the content)
   * is properly formatted just split on the rule terminator (`;`),
   * then split the contents of that array on the k:v
   * delimiter (`:`) and zip an object together with that.
   */
  return value.split(';').filter(function (p) {
    return !!p.trim();
  }).map(function (kv) {
    return kv.split(':');
  }).reduce(function (p, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    if (v !== undefined) p[k.trim()] = v.trim();
    return p;
  }, {});
}

/**
 * Returns a clone of the inline styles object with all properties
 * filtered out.
 *
 * @param {Object}
 * @param {...String}
 * @returns {Object}
 */
function filterInlineStyles(hash) {
  for (var _len = arguments.length, properties = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    properties[_key - 1] = arguments[_key];
  }

  return properties.reduce(function (p, k) {
    var v = hash[k];
    if (v !== undefined) p[k] = v;
    return p;
  }, {});
}

/**
 * Serializes a hash of property:value css rules into a
 * string that can be used as the value for an inline
 * `style` attribte.
 *
 * @param {Object}
 * @returns {String}
 */
function stringifyInlineStyles(hash) {
  return Object.keys(hash).map(function (k) {
    return k + ': ' + hash[k] + ';';
  }).join(' ');
}

var extractInlineStyleText = exports.extractInlineStyleText = function () {
  /**
   * Because of the order of the parameters we need
   * to partially apply `filterInlineStyles` in order
   * to sequence.
   *
   * @param {...String}
   * @returns {Function}
   * @private
   */
  function filter() {
    for (var _len2 = arguments.length, properties = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      properties[_key2] = arguments[_key2];
    }

    /**
     * @param {Object}
     * @returns {Object}
     * @private
     */
    return function (hash) {
      return filterInlineStyles.apply(undefined, [hash].concat(properties));
    };
  }

  /**
   * Takes a string containing inline styles and returns a string
   * containing the subset of rules for the specific properties (where
   * present).
   *
   * @param {String}
   * @param {...String}
   * @returns {String}
   */
  return function (value) {
    for (var _len3 = arguments.length, properties = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      properties[_key3 - 1] = arguments[_key3];
    }

    return (0, _picoDom.sequence)(parseInlineStyles, filter.apply(undefined, properties), stringifyInlineStyles)(value);
  };
}();

var createClassListFilterFn = exports.createClassListFilterFn = function () {
  /**
   * Parses a class list taken from the class attribute
   * of some element.
   *
   * TODO: Maybe a loop would be slightly more efficient... worth it?
   *
   * @param {String}
   * @returns {String}
   * @private
   */
  var parse = function parse() {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return str.split(' ').filter(function (x) {
      return !!x;
    }).reduce(function (p, c) {
      p[c.trim().toLowerCase()] = c;
      return p;
    }, {});
  };

  /**
   * Creates a class list filtering function.
   *
   * @param {Array}
   * @returns {Function}
   */
  return function () {
    var allowed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    allowed = allowed.map(function (c) {
      return c.toLowerCase();
    });

    /**
     * Returns a filtered class list.
     *
     * @param {String}
     * @returns {String}
     */
    return function () {
      var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var classList = '';
      var len = allowed.length;
      var hash = parse(str);

      while (len) {
        len--;
        var name = allowed[len];
        if (hash[name]) classList = (classList + ' ' + hash[name]).trim();
      }

      return classList;
    };
  };
}();